export class CustomError extends Error {
  isVisible?: boolean;

  constructor(message?: string) {
    super(message || "something went wrong");
    this.isVisible = true;
  }
}
